<template src="./template.html"></template>
<script>
  import _ from 'lodash';

  export default {
    name: 'error-message',

    props: {
      refName: String,
    },
    computed: {
      messages() {
        if (this.hasAsteriskInKey(this.refName)) {
          const [parent, child] = this.divideNamesByAsterisk(this.refName);
          let errors = this.$store.getters.getErrorByKey(parent);
          errors = _.flatten(_.map(errors, child));

          return _.compact(errors);
        }

        return this.$store.getters.getErrorByKey(this.refName);
      },

      hasErrorMessage() {
        return this.$root.$util.getLength(this.messages) > 0;
      },
    },
    methods: {
      divideNamesByAsterisk(names) {
        const segments = names.split('*');

        const parent = _.trim(segments[0], '.');
        const child = _.trim(segments[1], '.');

        return [parent, child];
      },

      hasAsteriskInKey(key) {
        return _.includes(key.split('.'), '*');
      },
    },
  };
</script>
